"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "body2ClassNames", {
    enumerable: true,
    get: function() {
        return _useBody2Stylesstyles.body2ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Body2"), exports);
const _useBody2Stylesstyles = require("./useBody2Styles.styles");
